function Romania({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1968)">
  <path d="M21.5651 0.995125C19.8318 0.352063 17.9571 8.31859e-09 16 8.31859e-09C14.0428 -6.24917e-05 12.1681 0.352063 10.4348 0.995125L9.04346 15.9999L10.4348 31.0047C12.168 31.648 14.0428 32 16 32C17.957 32 19.8318 31.648 21.5651 31.0047L22.9564 16L21.5651 0.995125Z" fill="#FFDA44"/>
  <path d="M32 16.0009C32 9.12153 27.658 3.25672 21.5652 0.996094V31.0058C27.658 28.745 31.9999 22.8804 32 16.0009Z" fill="#D80027"/>
  <path d="M0 16.0008C0 22.8803 4.342 28.7449 10.4347 31.0057L10.4347 0.996094C4.342 3.25672 0 9.12134 0 16.0008H0Z" fill="#0052B4"/>
  </g>
  </svg>

  `;

  return baseXml;
}

export default Romania;
